<template>
    <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
        <td class="no_padding drag_drop"><span></span></td>
        <td class="no_padding">
            <input type="checkbox"
                   :id="entity.id"
                   :value="entity.id"
                   @click.stop
                   @change="onChange"
                   :checked="isChecked"
            />
            <label :for="entity.id" @click.stop v-translate>Vybrat</label>
        </td>
        <td :data-th="'Název' | translate" class="first_data"><strong>{{ entity.name }}</strong></td>
        <td :data-th="'Operátor' | translate">
          <entity-link :id="entity.id_operator" type="operator">{{ entity.operator_name }}</entity-link>
        </td>
        <td :data-th="'Typ akce' | translate">{{ getActionTypeText(entity.action_type) }}</td>
        <td :data-th="'Počet zařízení příjemců' | translate">{{entity.recipients_count}}</td>
        <td :data-th="'Zpracováno' | translate" v-html="$_date_formatFull(entity.processed_at)"></td>
        <td :data-th="'Zobrazit v' | translate" v-html="$_date_formatFull(entity.show_at)"></td>
        <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"></td>

        <td class="no_padding edit">
            <div class="edit_inner">
                <a v-if="$_deleteActionAllowed" class="btn btn_action btn_delete" :title="'Smazat' | translate"
                   @click.prevent.stop="emitDeleteEntity" v-translate>Smazat</a>
            </div>
        </td>
    </tr>
</template>

<script>
	import rowActions from "@/components/mixins/row-actions"
  import advertisingBanners from "./mixins/advertisingBanners";
  import EntityLink from "../../common/EntityLink.vue";

	export default {
		name: "AdvertisingBannerRow",
    components: { EntityLink },
		mixins: [rowActions, advertisingBanners],
		data() {
			return {
				moduleName: 'AdvertisingBanners',
        detailPageRouteName: 'advertisingBannerDetail',
			}
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingBanner/AdvertisingBannerRow.vue